<div>
    <h2>{{'mantenimiento-etiquetas.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimiento-etiquetas.filters.listado' | translate}}</label>
                <app-filterable-list [itemsList]="versionesNiceLabel"
                    [selectedItem]="filtersForm.get('versionNiceLabel')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimiento-etiquetas.filters.nombreGrupo' | translate}}</label>
                <input type="text" formControlName="des">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimiento-etiquetas.filters.nombreFormato' | translate}}</label>
                <input type="text" formControlName="nombreFormato">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimiento-etiquetas.filters.configuracion' | translate}}</label>
                <app-filterable-list [itemsList]="configuraciones" [selectedItem]="filtersForm.get('configuracion')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimiento-etiquetas.filters.grados' | translate}}</label>
                <app-filterable-list [itemsList]="grados" [selectedItem]="filtersForm.get('grados')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimiento-etiquetas.filters.texto' | translate}}</label>
                <app-filterable-list [itemsList]="textosDenominacion"
                    [selectedItem]="filtersForm.get('textoDenominacion')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimiento-etiquetas.filters.tipoConfeccion' | translate}}</label>
                <app-filterable-list [itemsList]="tipos" [selectedItem]="filtersForm.get('tipoConfeccion')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimiento-etiquetas.filters.asignaciones' | translate}}</label>
                <app-filterable-list [itemsList]="yesNo" [selectedItem]="filtersForm.get('cargarAsignaciones')" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio" (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin" (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <input type="checkbox" id="1" formControlName="asDenominacion" (click)="addNivelAsignacion($event)">
                <label for="1">{{'mantenimiento-etiquetas.filters.as1' | translate}}</label>
            </div>
            <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <input type="checkbox" id="5" formControlName="asMarca" (click)="addNivelAsignacion($event)">
                <label for="5">{{'mantenimiento-etiquetas.filters.as2' | translate}}</label>
            </div>
            <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <input type="checkbox" id="2" formControlName="asPaisDenominacion" (click)="addNivelAsignacion($event)">
                <label for="2">{{'mantenimiento-etiquetas.filters.as3' | translate}}</label>
            </div>
            <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <input type="checkbox" id="6" formControlName="asMarcaPaisDenominacion"
                    (click)="addNivelAsignacion($event)">
                <label for="6">{{'mantenimiento-etiquetas.filters.as4' | translate}}</label>
            </div>
            <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <input type="checkbox" id="3" formControlName="asEtiquetadorDenominacion"
                    (click)="addNivelAsignacion($event)">
                <label for="3">{{'mantenimiento-etiquetas.filters.as5' | translate}}</label>
            </div>
            <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <input type="checkbox" id="7" formControlName="asEtiquetadorMarca" (click)="addNivelAsignacion($event)">
                <label for="7">{{'mantenimiento-etiquetas.filters.as6' | translate}}</label>
            </div>
            <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <input type="checkbox" id="8" formControlName="asLicenciaParametrizacion"
                    (click)="addNivelAsignacion($event)">
                <label for="8">{{'mantenimiento-etiquetas.filters.as7' | translate}}</label>
            </div>
            <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <input type="checkbox" id="9" formControlName="asLicenciaParametrizacionMarca"
                    (click)="addNivelAsignacion($event)">
                <label for="9">{{'mantenimiento-etiquetas.filters.as8' | translate}}</label>
            </div>
            <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="radio-group move-left-small move-left-next">
                <input type="radio" id="insercion" value="false" formControlName="dateType">
                <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
                <input type="radio" id="actualizacion" value="true" formControlName="dateType">
                <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
            </div>
            <div *ngIf="!this.isSmallScreen" class="entry-4"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="icon"></th>
                        <th class="id sortable" (click)="toOrderBy('x=> x.id', 2)">
                          {{'mantenimiento-etiquetas.table.id' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.id')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.des', 3)">
                          {{'mantenimiento-etiquetas.table.nombre' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.des')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.TipoConfeccion.des', 4)">
                          {{'mantenimiento-etiquetas.table.tipoConfeccion' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.TipoConfeccion.des')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.observaciones', 5)">
                          {{'mantenimiento-etiquetas.table.observaciones' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.observaciones')"></i></div>
                        </th>
                        <th class="date sortable" (click)="toOrderBy('x=> x.fechaIns', 6)">
                          {{'global.fecha.insercionShort' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.fechaIns')"></i></div>
                        </th>
                        <th class="date sortable" (click)="toOrderBy('x=> x.fechaUpd', 7)">
                          {{'global.fecha.actualizacionShort' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.fechaUpd')"></i></div>
                        </th>
                        <th class="action">
                          <i class="fas fa-plus" app-click-stop-propagation (click)="create()" title="{{'mantenimiento-etiquetas.tituloNew' | translate}}"></i>
                        </th>
                    </tr>
                </thead>
                <tbody class="clickable" *ngFor="let grupoEtiqueta of gruposEtiqueta; let i=index; trackBy: trackByGrupoEtiquetaId">
                    <tr (click)="grupoEtiqueta.asignaciones ? showDetails(i): null;"
                        [ngClass]="{'dropdownInfo': dropdownInfo === i}">
                        <td class="icon"><i  *ngIf="grupoEtiqueta.asignaciones" [ngClass]="dropdownInfo === i ? 'fas fa-angle-down' : 'fas fa-angle-right'"
                            title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                        </td>
                        <td class="id">{{grupoEtiqueta.id}}</td>
                        <td class="string">{{grupoEtiqueta.des}}</td>
                        <td class="string">{{grupoEtiqueta.desTipoConfeccion}}</td>
                        <td class="string">{{grupoEtiqueta.observaciones}}</td>
                        <td class="date">{{grupoEtiqueta.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="date">{{grupoEtiqueta.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="multi-actions">
                            <i class="fas fa-tag" (click)="openFormatos(grupoEtiqueta)" app-click-stop-propagation
                                title="{{'titles.formatosAsociados' | translate}}"></i>
                            <i class="fas fa-pencil-alt" (click)="update(grupoEtiqueta)" app-click-stop-propagation title="{{'titles.editar' | translate}}"></i>
                            <i class="far fa-trash-alt" (click)="askDelete(grupoEtiqueta)" app-click-stop-propagation
                                [ngClass]="{'disabled': grupoEtiqueta.registroEnUso}" title="{{'titles.eliminar' | translate}}"></i>
                        </td>
                    </tr>
                    <tr *ngIf="dropdownInfo === i">
                        <td colspan="8">
                            <div class="detail-long">
                                <div class="title">{{'global.masInformacion' | translate}}</div>
                                <div class="block-inline-long">
                                    <label>{{'mantenimiento-etiquetas.table.as1' | translate}}</label>
                                    <p>
                                        {{grupoEtiqueta.asignaciones[1] ? separarAsignaciones(grupoEtiqueta.asignaciones[1]) : 'Sin asignaciones'}}
                                    </p>
                                </div>
                                <div class="block-inline-long">
                                    <label>{{'mantenimiento-etiquetas.table.as2' | translate}}</label>
                                    <p>
                                        {{grupoEtiqueta.asignaciones[5] ? separarAsignaciones(grupoEtiqueta.asignaciones[5]) : 'Sin asignaciones'}}
                                    </p>
                                </div>
                                <div class="block-inline-long">
                                    <label>{{'mantenimiento-etiquetas.table.as3' | translate}}</label>
                                    <p>
                                        {{grupoEtiqueta.asignaciones[2] ? separarAsignaciones(grupoEtiqueta.asignaciones[2]) : 'Sin asignaciones'}}
                                    </p>
                                </div>
                                <div class="block-inline-long">
                                    <label>{{'mantenimiento-etiquetas.table.as4' | translate}}</label>
                                    <p>
                                        {{grupoEtiqueta.asignaciones[6] ? separarAsignaciones(grupoEtiqueta.asignaciones[6]) : 'Sin asignaciones'}}
                                    </p>
                                </div>
                                <div class="block-inline-long">
                                    <label>{{'mantenimiento-etiquetas.table.as5' | translate}}</label>
                                    <p>
                                        {{grupoEtiqueta.asignaciones[3] ? separarAsignaciones(grupoEtiqueta.asignaciones[3]) : 'Sin asignaciones'}}
                                    </p>
                                </div>
                                <div class="block-inline-long">
                                    <label>{{'mantenimiento-etiquetas.table.as6' | translate}}</label>
                                    <p>
                                        {{grupoEtiqueta.asignaciones[7] ? separarAsignaciones(grupoEtiqueta.asignaciones[7]) : 'Sin asignaciones'}}
                                    </p>
                                </div>
                                <div class="block-inline-long">
                                    <label>{{'mantenimiento-etiquetas.table.as7' | translate}}</label>
                                    <p>
                                        {{grupoEtiqueta.asignaciones[8] ? separarAsignaciones(grupoEtiqueta.asignaciones[8]) : 'Sin asignaciones'}}
                                    </p>
                                </div>
                                <div class="block-inline-long">
                                    <label>{{'mantenimiento-etiquetas.table.as8' | translate}}</label>
                                    <p>
                                        {{grupoEtiqueta.asignaciones[9] ? separarAsignaciones(grupoEtiqueta.asignaciones[9]) : 'Sin asignaciones'}}
                                    </p>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!gruposEtiqueta || (gruposEtiqueta && gruposEtiqueta.length < 1)">
                    <tr>
                        <td colspan="8">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="gruposEtiqueta && gruposEtiqueta.length > 0" [itemsPerPage]="itemsPerPage"
        [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
        (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
    <app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event">
    </app-toast>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{grupoEtiquetaId ? ('mantenimiento-etiquetas.tituloEdit' | translate) : ('mantenimiento-etiquetas.tituloNew' |
                translate)}}
            </h4>
        </header>
        <app-mantenimiento-etq-new-edit [grupoEtiquetaId]="grupoEtiquetaId" [tipos]="tipos"
            [versionesNiceLabel]="versionesNiceLabel" (refresh)="refresh($event)" (mensaje)="pushMessage($event)">
        </app-mantenimiento-etq-new-edit>
    </div>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="formatosModal">
    <div class="modal-content" id="modal-table">
        <header>
            <h4>{{'mantenimiento-etiquetas.tituloFormatos' | translate}}</h4>
        </header>
        <app-formatos-etiqueta class="component" [grupoEtiquetaId]="grupoEtiquetaId"
            [desGrupoEtiqueta]="desGrupoEtiqueta" (refresh)="refresh($event)" (mensaje)="pushMessage($event)">
        </app-formatos-etiqueta>
    </div>
</div>
